import { defineComponent } from "vue";
import netflixIcon from  "@/assets/covid/icons/icon-netflix.svg"

export default defineComponent({  
    data() {
      return {
         netflixIconPath: netflixIcon
      }
    }
});